// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import HeartOutlinedSvg from "@fishx/icons-svg/es/asn/HeartOutlined";
import FishxIcon from '../components/FishxIcon';

var HeartOutlined = function HeartOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: HeartOutlinedSvg
  }));
};

HeartOutlined.displayName = 'HeartOutlined';
export default React.forwardRef(HeartOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/HeartOutlined.js
// module id = 2913
// module chunks = 0